import { forwardRef, ReactElement } from 'react'
import classNames from 'classnames/bind'

import IconRwb from './icons/IconRwb'
import { useSideNavigationGlobalState } from './use-side-navigation-global-state'
import { SideNavigationItem, Props as SideNavigationItemProps } from './side-navigation-item'
import { RestrictByCapacity } from './restrict-by-capacity'
import { SideNavigationItemHidden } from './side-navigation-item-hidden'
import * as c from './constants'

import styles from './side-navigation.module.scss';

const cx = classNames.bind(styles)

const wideStyles = { width: c.MENU_WIDTH }
const narrowStyles = { width: c.MENU_WIDTH_COLLAPSED }

type Props = {
  className?: string
  onToggleStatus?: (status: 'wide' | 'narrow') => void
  children:
    | ReactElement<SideNavigationItemProps, typeof SideNavigationItem>
    | Array<ReactElement<SideNavigationItemProps, typeof SideNavigationItem>>
}

const SideNavigation = forwardRef<HTMLDivElement, Props>(
  ({ className, onToggleStatus, children }, ref) => {
    const { status, lock, toggleStatus, capacity } = useSideNavigationGlobalState()

    const widthStyle = status === 'wide' ? wideStyles : narrowStyles

    const toggleStatusCallback = () => {
      if (typeof onToggleStatus === 'function') {
        onToggleStatus(status === 'wide' ? 'narrow' : 'wide')
      }
      toggleStatus()
    }

    return (
      <div className={cx(styles.root, className)}>
        {/* invisible part */}
        <div className={cx(styles.hidden, c.NAVIGATION_HIDDEN_CLASS_NAME)}>
          <div className={styles.collapseHidden} />
          {children instanceof Array ? (
            children.map((child) => <SideNavigationItemHidden key={child.key} />)
          ) : (
            <SideNavigationItemHidden />
          )}
        </div>

        <div className={cx(styles.main, c.NAVIGATION_CLASS_NAME)} style={widthStyle} ref={ref}>
          {!lock && (
            <button
              aria-label="Переключить боковую навигацию в/из компактного вида"
              type="button"
              className={cx(styles.collapse, c.TOGGLE_BUTTON_CLASS_NAME)}
              onClick={toggleStatusCallback}
            >
              <IconRwb className={cx({ rw: true, flip: status === 'narrow' })} />
            </button>
          )}

          <RestrictByCapacity capacity={capacity} status={status}>
            {children}
          </RestrictByCapacity>
        </div>
      </div>
    )
  },
)

export default SideNavigation
